
import Component, { mixins } from 'vue-class-component';

import { ResponseStatus } from '@/common/types';
import AuthMixin from '@/mixins/authMixin';

@Component
export default class Login extends mixins(AuthMixin) {
  readonly forgottenPasswordUrl: string = process.env.VUE_APP_ZRD_AUTH_API_FORGOTTEN_PASSWORD_URL;

  username = '';

  usernameRules = [
    (value: string) => !!value || 'Benutzername ist ein Pflichtfeld.',
  ];

  password = '';

  passwordRules = [
    (value: string) => !!value || 'Passwort ist ein Pflichtfeld.',
  ];

  validForm = true;

  showPassword = false;

  get isAuthenticated(): boolean {
    return this.$store.getters.isAuthenticated;
  }

  get isFormLoading(): boolean {
    return this.authStatus === ResponseStatus.Loading;
  }

  get showFromError(): boolean {
    return this.authStatus === ResponseStatus.Error && this.authErrorData !== null;
  }

  mounted() {
    if (this.isAuthenticated) {
      this.$router.push('/');
    }
  }

  login() {
    const user = {
      username: this.username,
      password: this.password,
    };
    this.$store.commit('selectedDebitor', null);
    this.$store.dispatch('login', user)
      .then(() => {
        if (this.isAuthenticated) {
          this.$router.push('/');
          this.$store.dispatch('getDebitors');
          this.$store.dispatch('getUserInfo');
        }
      })
      .catch((error) => {});
  }

  onKeydownInput(event: KeyboardEvent) {
    if (this.validForm && event.key === 'Enter') {
      this.login();
    }
  }
}
